import "./about.scss";
import React, { useContext } from "react";

import useObserver from "../../utilities/UseObserver";
import ButtonGradient from "../../components/Button_Gradient/Button_Gradient";
import languageContext from "../../context/languageContext";

const About = () => {
  const { language } = useContext(languageContext);

  const [isIntersecting, refElement] = useObserver({
    rootMargin: "0px",
    root: null,
    threshold: 0.2,
  });

  let classNameEffect = isIntersecting ? "--in" : "--out";

  return (
    <div className="about-container" ref={refElement} id="sobre-mi">
      <section className={`all-text all-text${classNameEffect}`}>
        <h3
          className={`all-text__title all-text__title${classNameEffect} heading-secondary`}
        >
          {language.textAboutMe.title}
        </h3>
        <div className={`text-container text-container${classNameEffect}`}>
          <p className="text-container__paragraph">
            {language.textAboutMe.paragraphOne}
          </p>
          <p className="text-container__paragraph">
            {language.textAboutMe.paragraphTwo}
          </p>
          <p className="text-container__paragraph">
            {language.textAboutMe.paragraphThree}
          </p>
        </div>
      </section>
      <section className="all-images">
        <div className={`personal-pic personal-pic${classNameEffect}`}>
          <img
            className={`personal-pic__picture-me`}
            src={require("../../assets/perfil-icon/option2.png")}
            alt="frontend-developer"
          />
        </div>
        <div
          className={`button-gradient-container button-gradient-container${classNameEffect}`}
        >
          <ButtonGradient
            textContent={"Descargar CV PDF"}
            hrefLink={require("../../assets/PDF-CV/CV-Rodrigo Orozco.pdf")}
            downloadOptions={"RodrigoOrozco-FrontendDeveloper.pdf"}
          />
        </div>
      </section>
    </div>
  );
};

export default About;
